import { render } from "./orcamentoemdigitacao.vue?vue&type=template&id=2148dc4a&scoped=true"
import script from "./orcamentoemdigitacao.vue?vue&type=script&lang=js"
export * from "./orcamentoemdigitacao.vue?vue&type=script&lang=js"

import "./orcamentoemdigitacao.vue?vue&type=style&index=0&id=2148dc4a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2148dc4a"]])

export default __exports__